export interface Order {
  bpNumber: string;
  customerName: string;
  employeeId: string;
  totalAmount: number;
  id: number;
  orderDate: string;
  orderNumber: string;
  poNumber: string;
  salesRepresentative: string;
  status: string;
  quoteNumber: string;
}

export class LnOrderResponse {
  count = 0;
  lnOrders: Order[] = [];
}
